import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({  
  homeworkId,
  definition
}) {
  return (
    <StudentsUIProvider studentsUIParameters={{ homeworkId, definition }}>
      <StudentsCard />
    </StudentsUIProvider>
 );
}